import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	GenerateHuaweiRemoteAnalysisRequest
} from '../requests/HuaweiRemoteAnalysisRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ProcessFileHuaweiRemoteAnalysis = (fileLocation, userId) => async (dispatch) => {
	await GenerateHuaweiRemoteAnalysisRequest(fileLocation, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateHuaweiRemoteAnalysis = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFileHuaweiRemoteAnalysis(response.data, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
